import React from "react/lib/ReactWithAddons";
import {keycloakURL, loginURL, notifications, serverCache} from "../data/server";


export const LocalLogin = React.createClass({
    mixins: [React.addons.LinkedStateMixin],

    getInitialState() {
        return {
            user_email: "",
            password: "",
        }
    },

    componentWillUnmount() {
        serverCache.store.setIn(['just_logged_in'], false);
    },

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    },

    onUserEmailChange(event) {
        this.setState({user_email: event.target.value});
    },

    onPasswordChange(event) {
        this.setState({password:event.target.value});
    },

    sendAuthReq(e) {
        e.preventDefault();
        notifications.clearAll();
        var data = {
            user_email: this.state.user_email,
            password: this.state.password
        };
        const temp_serverCache = serverCache;
        serverCache.sendAuthReq(data,
            (() => {
                notifications.success("The login is successful.");
                temp_serverCache.setUserAfterLocalLogin();
                temp_serverCache.store.setIn(['just_logged_in'], true);
            }),
            () => {
                notifications.danger("Your credentials are wrong. " +
                    "Please try again.");
                this.setState({sending:false});
            });
    },

    render: function () {
        const user = serverCache.getUser();
        const stitle = {marginTop:'1em'};
        const info = serverCache.getInfo();
        const login_options = info.get("login_options");
        const login_form = (
            <div>
                <form className="form-horizontal" onSubmit={this.sendAuthReq}>
                    {
                        login_options.get("IS_LOCALLOGIN") ? (
                            <div>
                                <div className="form-group row">
                                    <label className="col-sm-3 control-label" style={stitle}>
                                        <span style={{float:'right'}}>Username</span>
                                    </label>
                                    <div className="col-sm-3" style={{marginTop:'1em'}}>
                                        <input type="text" className="form-control" id="user_email" name="user_email" value={this.state.user_email}
                                               onChange={this.onUserEmailChange}  required />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 control-label" style={stitle}>
                                        <span style={{float:'right'}}>Password</span>
                                    </label>
                                    <div className="col-sm-3" style={{marginTop:'1em'}}>
                                        <input type="password" className="form-control" id="password" name="password" value={this.state.password}
                                               onChange={this.onPasswordChange} required
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-offset-3 col-sm-3">
                                <button type="submit" className="btn btn-primary btn-default btn-block">
                                Login
                                </button>
                                </div>
                                <div className="form-group row align-items-center">
                                </div>
                            </div>
                        ) : (<p></p>)
                    }
                </form>
                <div className="col-sm-offset-6 col-sm-3" id="register_or_login">
                    {
                        login_options.get("IS_KEYCLOAK") ? (
                            <div>
                                <p><a href={keycloakURL}> Login via GWDG Keycloak </a></p>
                            </div>
                        ) : (<p></p>)
                    }
                    {
                        login_options.get("IS_B2ACCESS") ? (
                            <div>
                                <p><a href={loginURL}> Login via B2ACCESS </a></p>
                                <p>or</p>
                                <p><a href={this.props.b2access_registration_link}> Register </a></p>
                            </div>
                        ) : (<p></p>)
                    }
                </div>
            </div>


        );
        if (user === null || user === undefined) {
            return login_form;
        } else {
            if (user.size > 0) {
                let just_logged_in = serverCache.store.getIn(['just_logged_in'], false);
                /* Only show the notification 'already logged in' if the user accesses this page
                 time after they logged in.
                */
                if(!just_logged_in) {
                    notifications.success("You are already logged in.");
                }
                return (<div></div>);
            }
            else return login_form;
        }
    }
});



// WEBPACK FOOTER //
// ./src/components/locallogin.jsx